import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Alert, Form, Spinner } from 'reactstrap';
import Logo from "../../images/logo.svg";
import LogoDark from "../../images/logo.svg";
import { Link } from "react-router-dom";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard
} from '../../components/Component';
import { useAuth } from '../../context/auth.context';
import { useDataFetch } from '../../hooks/useDataFetch';
import Head from '../../layout/head/Head';
import { saveToLocalStorage } from '../../utils/storage';
import AuthFooter from './AuthFooter';
import { toast } from 'react-toastify';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState('');
  

  const navigate = useNavigate();

  const { login: loginContext, sesionExpirada } = useAuth();

  const { postData } = useDataFetch();

  // Sin el aviso genérico de postData: salía en cada intento, también con la
  // clave equivocada, y como el login no tiene ToastContainer los avisos se
  // acumulaban y aparecían todos juntos al entrar al panel. El aviso de
  // bienvenida se lanza abajo, solo cuando la clave es correcta; un error se
  // muestra en la propia página.
  const { mutateAsync: login } = postData(
    '/login',
    {},
    {},
    { onSuccess: () => {} }
  );

  const onFormSubmit = async formData => {
    setLoading(true);

    const response = await login({
      email: formData.name,
      password: formData.passcode
    });
    if (response.status) {
      saveToLocalStorage('user', response.data);
      loginContext();
      // Aquí no hay ToastContainer: react-toastify lo deja en cola y lo
      // muestra una sola vez al abrirse el panel.
      toast.success(
        response.data?.name
          ? `Sesión iniciada. Bienvenido, ${response.data.name}.`
          : 'Sesión iniciada.'
      );
      setTimeout(() => {
        
        navigate(`${process.env.PUBLIC_URL}/dashboard`);
      }, 20);
    } else {
      setTimeout(() => {
        setError('No existe ningun usuario creado con esta información');
        setLoading(false);
      }, 1000);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  return (
    <>
      <Head title='Login' />
      <Block className='nk-block-middle nk-auth-body  wide-xs'>
        <div className='brand-logo pb-4 text-center'>
          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
            <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
            <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
          </Link>
        </div>

        <PreviewCard className='' bodyClass='card-inner-lg'>
          <BlockHead>
            <BlockContent>
              <BlockTitle tag='h4'>Inicio de sesión</BlockTitle>
              <BlockDes>
                <p>Accede usando tu correo electrónico y clave.</p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          {errorVal && (
            <div className='mb-3'>
              <Alert color='danger' className='alert-icon'>
                <Icon name='alert-circle' /> No es posible iniciar sesión{' '}
              </Alert>
            </div>
          )}
          {/* Aquí no hay avisos flotantes (el ToastContainer vive en el diseño
              con menú lateral), así que el motivo se muestra en la página. */}
          {sesionExpirada && !errorVal && (
            <div className='mb-3'>
              <Alert color='warning' className='alert-icon'>
                <Icon name='clock' /> Tu sesión expiró. Vuelve a iniciar sesión
                para continuar.
              </Alert>
            </div>
          )}
          <Form className='is-alter' onSubmit={handleSubmit(onFormSubmit)}>
            <div className='form-group'>
              <div className='form-label-group'>
                <label className='form-label' htmlFor='default-01'>
                  Correo electrónico
                </label>
              </div>
              <div className='form-control-wrap'>
                <input
                  type='text'
                  id='default-01'
                  {...register('name', { required: 'This field is required' })}

                  placeholder='Correo electrónico'
                  className='form-control-lg form-control'
                />
                {errors.name && (
                  <span className='invalid'>{errors.name.message}</span>
                )}
              </div>
            </div>
            <div className='form-group'>
              <div className='form-label-group'>
                <label className='form-label' htmlFor='password'>
                  Clave
                </label>
                {/* <Link
                  className='link link-primary link-sm'
                  to={`${process.env.PUBLIC_URL}/auth-reset`}
                >
                  Forgot Code?
                </Link> */}
              </div>
              <div className='form-control-wrap'>
                <a
                  href='#password'
                  onClick={ev => {
                    ev.preventDefault();
                    setPassState(!passState);
                  }}
                  className={`form-icon lg form-icon-right passcode-switch ${
                    passState ? 'is-hidden' : 'is-shown'
                  }`}
                >
                  <Icon name='eye' className='passcode-icon icon-show'></Icon>

                  <Icon
                    name='eye-off'
                    className='passcode-icon icon-hide'
                  ></Icon>
                </a>
                <input
                  type={passState ? 'text' : 'password'}
                  id='password'
                  {...register('passcode', {
                    required: 'This field is required'
                  })}
                  placeholder='Ingrese la contraseña'
                  className={`form-control-lg form-control ${
                    passState ? 'is-hidden' : 'is-shown'
                  }`}
                />
                {errors.passcode && (
                  <span className='invalid'>{errors.passcode.message}</span>
                )}
              </div>
            </div>
            <div className='form-group'>
              <Button
                size='lg'
                className='btn-block'
                type='submit'
                color='primary'
              >
                {loading ? <Spinner size='sm' color='light' /> : 'Ingresar'}
              </Button>
            </div>
          </Form>
          
        </PreviewCard>
      </Block>
      <AuthFooter />
    </>
  );
};
export default Login;
